export default __webpack_public_path__ + "static/media/M14.9ede3a42.svg";